module.exports = __webpack_public_path__ + "img/ecommerce-installed.81389c73.png";